import '../styles/index.scss';
import { HHDSIcon, HHDSIconTagName } from './Icon/Icon';
import { HHDSRichText, HHDSRichTextTagName } from './RichText/RichText';
import { HHDSSalesforce, HHDSSalesforceTagName } from './Salesforce/Salesforce';
import { HHDSHero, HHDSHeroTagName } from './Hero/Hero';
import { HHDSImage, HHDSImageTagName } from './Image/Image';
import { HHDSCarousel, HHDSCarouselTagName } from './Carousel/Carousel';
import { HHDSVideoDirect, HHDSVideoDirectTagName } from './VideoDirect/VideoDirect';
import { HHDSButtonPagination, HHDSButtonPaginationTagName } from './ButtonPagination/ButtonPagination';
import { HHDSButtonHero, HHDSButtonHeroTagName } from './ButtonHero/ButtonHero';
import { HHDSHeadingAndText, HHDSHeadingAndTextTagName } from './HeadingAndText/HeadingAndText';
import { HHDSMasthead, HHDSMastheadTagName } from './Masthead/Masthead';
import { HHDSDominoCard, HHDSDominoCardTagName } from './DominoCard/DominoCard';
import { HHDSImageCarousel, HHDSImageCarouselTagName } from './ImageCarousel/ImageCarousel';
import { HHDSImageGrid, HHDSImageGridTagName } from './ImageGrid/ImageGrid';
import { HHDSCTA, HHDSCTATagName } from './CTA/CTA';
import { HHDSLongFormText, HHDSLongFormTextTagName } from './LongFormText/LongFormText';
import { HHDSButtonHeader, HHDSButtonHeaderTagName } from './ButtonHeader/ButtonHeader';
import { HHDSVideoVimeo, HHDSVideoVimeoTagName } from './VideoVimeo/VideoVimeo';
import { HHDSSplitImageSlider, HHDSSplitImageSliderTagName } from './SplitImageSlider/SplitImageSlider';
import { HHDSImageCompare, HHDSImageCompareTagName } from './ImageCompare/ImageCompare';
import { HHDSInlineImage, HHDSInlineImageTagName } from './InlineImage/InlineImage';
import { HHDSMapGrid, HHDSMapGridTagName } from './MapGrid/MapGrid';
import { HHDSVideoGallery, HHDSVideoGalleryTagName } from './VideoGallery/VideoGallery';
import { HHDSVideoCard, HHDSVideoCardTagName } from './VideoCard/VideoCard';
import { HHDSFloorPlate, HHDSFloorPlateTagName } from './FloorPlate/FloorPlate';
import { HHDSDialog, HHDSDialogTagName } from './Dialog/Dialog';
import { HHDSResidenceCard, HHDSResidenceCardTagName } from './ResidenceCard/ResidenceCard';
import { HHDSButtonResidenceClose, HHDSButtonResidenceCloseTagName } from './ButtonResidenceClose/ButtonResidenceClose';
import { HHDSAmenities, HHDSAmenitiesTagName } from './Amenities/Amenities';
import { HHDSFilteredGallery, HHDSFilteredGalleryTagName } from './FilteredGallery/FilteredGallery';
import { HHDSHeroVideoPlayer, HHDSHeroVideoPlayerTagName } from './HeroVideoPlayer/HeroVideoPlayer';
import { HHDSGlobe, HHDSGlobeTagName } from './Globe/Globe';
/* End imports */

const componentList: any[] = [];
componentList.push({ name: HHDSIconTagName, component: HHDSIcon });
componentList.push({
	name: HHDSRichTextTagName,
	component: HHDSRichText,
});
componentList.push({ name: HHDSSalesforceTagName, component: HHDSSalesforce });
componentList.push({ name: HHDSHeroTagName, component: HHDSHero });
componentList.push({ name: HHDSImageTagName, component: HHDSImage });
componentList.push({ name: HHDSCarouselTagName, component: HHDSCarousel });
componentList.push({ name: HHDSVideoDirectTagName, component: HHDSVideoDirect });
componentList.push({ name: HHDSButtonPaginationTagName, component: HHDSButtonPagination });
componentList.push({ name: HHDSButtonHeroTagName, component: HHDSButtonHero });
componentList.push({ name: HHDSHeadingAndTextTagName, component: HHDSHeadingAndText });
componentList.push({ name: HHDSMastheadTagName, component: HHDSMasthead });
componentList.push({ name: HHDSDominoCardTagName, component: HHDSDominoCard });
componentList.push({ name: HHDSImageCarouselTagName, component: HHDSImageCarousel });
componentList.push({ name: HHDSImageGridTagName, component: HHDSImageGrid });
componentList.push({ name: HHDSCTATagName, component: HHDSCTA });
componentList.push({ name: HHDSLongFormTextTagName, component: HHDSLongFormText });
componentList.push({ name: HHDSButtonHeaderTagName, component: HHDSButtonHeader });
componentList.push({ name: HHDSVideoVimeoTagName, component: HHDSVideoVimeo });
componentList.push({ name: HHDSSplitImageSliderTagName, component: HHDSSplitImageSlider });
componentList.push({ name: HHDSImageCompareTagName, component: HHDSImageCompare });
componentList.push({ name: HHDSInlineImageTagName, component: HHDSInlineImage });
componentList.push({ name: HHDSMapGridTagName, component: HHDSMapGrid });
componentList.push({ name: HHDSVideoGalleryTagName, component: HHDSVideoGallery });
componentList.push({ name: HHDSVideoCardTagName, component: HHDSVideoCard });
componentList.push({ name: HHDSFloorPlateTagName, component: HHDSFloorPlate });
componentList.push({ name: HHDSDialogTagName, component: HHDSDialog });
componentList.push({ name: HHDSResidenceCardTagName, component: HHDSResidenceCard });
componentList.push({ name: HHDSButtonResidenceCloseTagName, component: HHDSButtonResidenceClose });
componentList.push({ name: HHDSAmenitiesTagName, component: HHDSAmenities });
componentList.push({ name: HHDSFilteredGalleryTagName, component: HHDSFilteredGallery });
componentList.push({ name: HHDSHeroVideoPlayerTagName, component: HHDSHeroVideoPlayer });
componentList.push({ name: HHDSGlobeTagName, component: HHDSGlobe });
componentList.push({ name: HHDSGlobeTagName, component: HHDSGlobe });
/* End component list */

export namespace Components {
	export function register(verbose: boolean = false, note: string = ''): void {
		let targetNames: string[] = [];
		componentList.forEach((target: any) => {
			if (!customElements.get(target.name)) {
				targetNames.push(target.name);
				customElements.define(target.name, target.component);
			}
		});
		if (targetNames.length && verbose) logger.log(`${note} registered components: ${targetNames.sort().join(', ')}`);
	}
}
